import { CDefine, CEnumTypes, CMJClass } from "./CEnumTypes";
import { CByteArray } from "./CByteArray";
import { CMJGame } from "./CMJGame";
import { CTPGHState } from "./CTPGHState";
import { CGame } from "./CGame";

export class CMJPlayer {
    private m_MJ:CMJGame;
    protected m_idxTB:number;
    protected m_wTPGH:number;
    public m_nPlayerNum:number;
    private m_comIntf:fgui.GComponent;

    public m_Cards:CByteArray = new CByteArray(CDefine.CARDS_PER_PLAYER + 2);
    public m_Hua1Pai2:CByteArray = new CByteArray(8);
    public m_OutVal:CByteArray = new CByteArray(10);
    public m_byPType:CByteArray = new CByteArray(10);
    public m_byHuCard:CByteArray = new CByteArray(24);
    public m_Flag:CByteArray = new CByteArray(4);	// 0 for host check player ready, 1 press ting, 2 代打, 3 已打牌
    public m_ocTPGH:CByteArray = new CByteArray(2);
    public m_bCardIn:CByteArray = new CByteArray(4);
    public m_fgCardIn:number;
    public m_LimitCardOut:CByteArray = new CByteArray(2);

    public m_nOutC:number;
    public m_nWind:number;
    public m_nOutCnt:number;
    public m_nHuaCnt:number;
    public m_fgGun:number;
    public m_huoSkip:number;
    public m_fgSpec:number;
    public m_fgTing:number;
    public m_iPCnt:number;
    public m_nTingFg:number;
    public m_incSC:number;
    public m_iScore:number;
    //public m_iResult:number
    public m_cntBonus:number
    public m_LastPonV:number;
    public m_ansDismiss:number;

    public m_cntZimo:number;
    public m_cntHu:number;
    public m_cntBeHu:number;

    //public m_fsTing:fgui.GMovieClip;
    public m_fsTing:fgui.GComponent;
    public m_tpState:CTPGHState = new CTPGHState();

    public constructor() {
        this.Reset(1);
	}

    public Reset(md:number = 0):void {
        //m_tmC = 0;
        this.m_fgCardIn = 0;
        this.m_ansDismiss = 0;
        if( md ) {
            this.m_nWind = 0;
            this.m_iScore = 0;
            this.m_nPlayerNum = md-1;
            this.m_nOutC = -1;
            this.m_nHuaCnt = this.m_nOutCnt = 0;
            this.m_wTPGH = 0;
            this.m_bCardIn.SetInt(0, 0);
            this.m_fgGun = 0;
            this.m_huoSkip = 0;
            this.m_fgSpec = 0;
            this.m_fgTing = 0;
            this.m_iPCnt = 0;
            this.m_nTingFg = 0;
            this.m_LastPonV = 255;

            this.m_Flag.Reset(0);
            this.m_ocTPGH.Reset(0);
            this.m_OutVal.Reset(0);
            this.m_byPType.Reset(0);
            this.m_byHuCard.Reset(0);
            this.m_Hua1Pai2.Reset(0);
            this.m_LimitCardOut.Reset(0);
            this.m_Cards.Reset(255);
        }
        else {
            this.m_LastPonV = 255;
            this.m_wTPGH = 0;
            this.m_fgGun = 0;
            this.m_fgSpec= 0;
            this.m_fgTing = 0;
            this.m_iPCnt = 0;
            this.m_bCardIn.SetInt(0, 0);
            this.m_nHuaCnt = this.m_nOutCnt = 0;
            this.m_nTingFg = 0;
            this.m_huoSkip = 0;
            this.m_nOutC = -1;
            this.m_Cards.Reset(255);
            this.m_LimitCardOut.Reset(0);
            this.m_Flag[0] = this.m_Flag[1] = this.m_Flag[3] = 0;
        }
        this.m_cntBonus = 0;
    }

    public IsRobot():boolean { 
        return (this.m_MJ.GTable.IsRobot(this.m_idxTB));
    }
    public IsOffLine():boolean { return (this.m_MJ.GTable.IsOffLine(this.m_idxTB)); }
    public GetIndex():number { return this.m_idxTB; }
    public GetGold():number { return this.m_iScore; }
    public PlusGValue(v:number):number {
        this.m_iScore += v;
        return this.m_iScore;
    }
    public GetDBID():number { return this.m_MJ.GTable.player[this.m_idxTB].DBID; }
    public GetName():string { return this.m_MJ.GTable.player[this.m_idxTB].socialName; }
	public GetAvatar():string { return this.m_MJ.GTable.player[this.m_idxTB].pictureURL; }
    public GetPlayerNum():number { return this.m_nPlayerNum; }
    public GetTPGH():number { return this.m_wTPGH; }
    public SetTPGH(v:number):void { this.m_wTPGH = v; }
    public AddTPGH(v:number):void { this.m_wTPGH |= v; }
    public SubTPGH(v:number):void {
        this.m_wTPGH &= (0xffffffff ^ v); 
        CGame.DebugLog("*** SubTPGH:", v);
    }

    public Init(idxTB:number, mj:CMJGame):void {
        this.Reset(1);
        
        this.m_MJ = mj;
        this.m_idxTB = idxTB;
        //m_gMsg = CGameMsg.Instance;
        this.m_iScore = 0;
    }

    public isTing():boolean { return this.m_fsTing.visible; }
    public ShowTing(show:boolean):void {
        this.m_fsTing.visible = show;
        // if( show ) {
        //     let t = this.m_fsTing.getTransition("ting");
        //     console.log(t);
        //     t.play();
        // }
    }
    
    public SetPlayerNum(pos:number):void {
        this.m_nPlayerNum = pos;
        let mc = this.m_MJ.m_mcLayout.getChild("mc_tpState" + this.m_nPlayerNum) as fgui.GMovieClip;
        this.m_tpState.attachMC(mc);
        let com = this.m_MJ.m_mcLayout.getChild("mc_Ting" + this.m_nPlayerNum) as fgui.GComponent;
        this.m_fsTing = com;
        this.m_comIntf = this.m_MJ.m_mcLayout.getChild("mc_PlayerIntf" + this.m_nPlayerNum) as fgui.GComponent;
        // mc = this.m_comIntf.getChild("mc_UIBG") as fgui.GMovieClip;
        // mc.playing = false;
        // mc.frame = 0;
        let dm = this.m_comIntf.getChild("mc_stDismiss") as fgui.GMovieClip;
        dm.visible = false;
    }
    
    public DisplayDealer(idx:number = -1):void {
        let m = this.m_comIntf.getChild("mc_Dealer") as fgui.GImage;
        let t = this.m_comIntf.getChild("txt_DealerCnt") as fgui.GTextField;
        if ( this.m_MJ.m_Dealer == idx ) {
            m.visible = true;
            t.visible = false;
            if ( this.m_MJ.m_DealerCnt > 0 ) {
                t.visible = true;
                t.text = "x" + this.m_MJ.m_DealerCnt;
            }
        }
        else {
            m.visible = false;
            t.visible = false;
        }
    }

    public updateAnsDismiss(show:boolean):void {
        let dm = this.m_comIntf.getChild("mc_stDismiss") as fgui.GMovieClip;
        dm.frame = this.m_ansDismiss;
        dm.visible = show;
    }

    public UpdateInfo(name:boolean, idx:number = -1):void {
        let gp = this.m_MJ.GTable.player[this.m_idxTB];
        if( name ) {
            this.m_comIntf.visible = true;
            if( this.GetAvatar() != "none" ) {
                let avatar = this.m_comIntf.getChild("avatar") as fgui.GLoader;
                if( avatar.texture ) avatar.texture = null;
                avatar.texture = PIXI.Texture.from(gp.pictureURL);
            }
            let t = this.m_comIntf.getChild("txt_Name") as fgui.GTextField;
            t.text = gp.socialName;
            let dm = this.m_comIntf.getChild("mc_stDismiss") as fgui.GMovieClip;
            dm.visible = false;
        }
        let mc = this.m_comIntf.getChild("mc_Wind") as fgui.GMovieClip;
        mc.frame = this.m_MJ.m_RoundWind;
        mc = this.m_comIntf.getChild("mc_Pos") as fgui.GMovieClip;
        mc.frame = this.m_nWind;
        let t = this.m_comIntf.getChild("txt_Score") as fgui.GTextField;
        let sc = this.m_iScore / CDefine.GOLD_MULTI_BASE;
        t.text = '' + sc.toFixed(1);

        if( idx != -1 ) {
            let m = this.m_comIntf.getChild("mc_Dealer") as fgui.GImage;
            t = this.m_comIntf.getChild("txt_DealerCnt") as fgui.GTextField;
            m.visible = false;
            t.visible = false;
            if ( this.m_MJ.m_Dealer == idx ) {
                m.visible = true;
                if ( this.m_MJ.m_DealerCnt > 0 ) {
                    t.visible = true;
                    t.text = "x" + this.m_MJ.m_DealerCnt;
                }
            }
        }
    }

    public SortCards(bCardIn:boolean = false):void {
        var i:number, j:number, fg:number, ofs:number;
        var v1:number, v2:number, count:number = CDefine.CARDS_PER_PLAYER;

        ofs = this.m_iPCnt * 3;
        if( bCardIn ) count ++;
        count -= (this.m_iPCnt*3);
        j = count;
        while( j > 1 ) {
            j >>= 1;
            do {
                fg = 1;
                for( i = 0; i < count-j; i ++ ) {
                    v1 = this.m_MJ.m_cCards[this.m_Cards[ofs+i]].GetV();
                    v2 = this.m_MJ.m_cCards[this.m_Cards[ofs+i+j]].GetV();
                    if( v1 > v2 ) {
                        this.m_MJ.m_cCards[this.m_Cards[ofs+i]].ChgV(v2);
                        this.m_MJ.m_cCards[this.m_Cards[ofs+i+j]].ChgV(v1);
                        fg = 0;
                    }
                }
            } while( !fg );
        }
    }

    public EnableCards(enable:boolean, ting:number=0):void {
        var i:number, n:number;
        if ( this.isTing() ) return;
        CGame.DebugLog("   EnableCards:" + enable);
        if( enable == false ) {
            //this.m_MJ.m_cCntDown.Reset();
            if ( this.m_MJ.m_cTPGH.GetState() ) this.m_MJ.m_cTPGH.Out();
            for ( i = 0; i <= CDefine.CARDS_PER_PLAYER; i ++ ) {
                if( this.m_Cards[i] != 255 )
                    this.m_MJ.m_cCards[this.m_Cards[i]].SetEnable(enable);
            }
        }
        else {
            if( this.m_huoSkip ) this.m_huoSkip ++;
            if( !this.isTing() ) {
                n = 0;
                for( i = this.m_iPCnt*3; i <= CDefine.CARDS_PER_PLAYER; i ++ ) {
                    if( this.m_MJ.m_cCards[this.m_Cards[i]].GetV() == this.m_LimitCardOut[0] ||
                        this.m_MJ.m_cCards[this.m_Cards[i]].GetV() == this.m_LimitCardOut[1] ) {
                        this.m_MJ.m_cCards[this.m_Cards[i]].SetEnable(false);
                        CGame.DebugLog("enable false!!", this.m_MJ.m_cCards[this.m_Cards[i]].GetV(), 
                            this.m_LimitCardOut[0], this.m_LimitCardOut[1]);
                        continue;
                    }
                    this.m_MJ.m_cCards[this.m_Cards[i]].SetEnable(enable);
                    this.m_MJ.m_cCards[this.m_Cards[i]].SetData(i);
                    n ++;
                }
                if( n == 0 ) {
                    for( i = this.m_iPCnt*3; i <= CDefine.CARDS_PER_PLAYER; i ++ ) {
                        this.m_MJ.m_cCards[this.m_Cards[i]].SetEnable(enable);
                        this.m_MJ.m_cCards[this.m_Cards[i]].SetData(i);
                    }
                }
                //this.m_MJ.m_cCntDown.Show();
                //if( this.m_MJ.m_Core.CanBeTING(this) ) { 
                if( ting != 0 ) { 
                    this.m_MJ.m_cTPGH.In(CDefine.MJACTION_TING, 0); 
                }
            }
        }
    }
}